export default "__VITE_ASSET__CwiWh73r__"